import React from 'react';
import { Button } from '@mui/material';

interface OnboardingSkipFooterProps {
  onDismiss: () => void;
  label?: string;
}

const OnboardingSkipFooter: React.FC<OnboardingSkipFooterProps> = ({
  onDismiss,
  label = "I'll set this up later",
}) => (
  <Button variant="text" onClick={onDismiss}>
    {label}
  </Button>
);

export default OnboardingSkipFooter;
